import type { ICellValue, ITextFieldProperty } from '../types'

import { getFieldDefaultProperty } from '../constants'
import { FieldType } from '../types'
import { TextBaseField } from './text-base-field'

export class TextField extends TextBaseField {
	cellValueToOpenValue(cellValue: ICellValue): string | null {
		return cellValue as string
	}
	openWriteValueToCellValue(openWriteValue: string | null): ICellValue {
		return openWriteValue as string
	}
	cellValueToApiStandardValue(cellValue: ICellValue): string | null {
		return cellValue as string
	}
	cellValueToApiStringValue(cellValue: ICellValue): string | null {
		return cellValue as string
	}
	validate(value: any): boolean {
		return typeof value === 'string'
	}
	static defaultProperty() {
		return getFieldDefaultProperty(FieldType.Text) as ITextFieldProperty
	}
}
